import React from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableBody,
  Box,
  Typography,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTheme } from "@emotion/react";
import StyledTableCell from "../Common/styledTableCell";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { CustomTooltip } from "../../Utils/handler";

const useStyles = makeStyles()((theme) => ({
  main: {
    padding: 0,
    "thead th": {
      color: theme.palette.primary.main,
      fontSize: "15px",
      padding: "5px",
    },
    tbody: {
      "tr:first-child td": {
        backgroundColor: "#FFFFFF",
        padding: "4px 0 12px 0",
      },
      "tr td": {
        backgroundColor: "#F8F8F8",
        borderBottom: "none",
        margin: 8,
      },
      "td:first-child": {
        borderRadius: "8px 0 0 8px",
      },
      "td:last-child": {
        borderRadius: "0 8px 8px 0",
      },
    },
  },
}));

const CommonTable = ({
  headerList,
  children,
  minWidth,
  align,
  sx,
  sorting,
  setSorting,
  backgroundColor,
  size,
  isNotSorting
}) => {
  const { classes } = useStyles();
  const theme = useTheme();

  return (
    <TableContainer
      sx={{ ...sx, width: "100%", overflowX: "auto", borderRadius: "10px" }}
      elevation={0}
    // className={classes.main}
    >
      <Box>
        <Table
          sx={{ minWidth: minWidth || 650 }}
          size={size || "small"}
          aria-label="order table"
        >
          <TableHead
            sx={{
              backgroundColor: backgroundColor || theme?.palette?.primary?.main,
              "& th": { color: "#fff" },
            }}
          >
            <TableRow>
              {headerList &&
                headerList.map((item, index) => (
                  <StyledTableCell
                    key={index}
                    sx={{ padding: "8px" }}
                    align={align || "center"}
                  >
                    <Typography
                      display={"flex"}
                      sx={{
                        color: theme?.palette?.bgLightWhite?.main,
                        fontSize: 14,
                        lineHeight: "1.2rem",
                      }}
                      alignItems={"center"}
                      justifyContent={"center"}
                    >
                      {item}{" "}
                      {((item == "PPSK ID" ||
                        item == "Submitted Date" ||
                        item == "Updated Date" ||
                        item == "Verified By" ||
                        item == "Remaining Renew Days" ||
                        item == "Payment Date") && !isNotSorting) && (
                          <CustomTooltip
                            title={
                              item == "PPSK ID"
                                ? sorting?.isPpskId == "0" ||
                                  sorting?.isPpskId == ""
                                  ? "Descending"
                                  : "Ascending"
                                : item == "Submitted Date"
                                  ? sorting?.isSubmittedDate == "0" ||
                                    sorting?.isSubmittedDate == ""
                                    ? "Descending"
                                    : "Ascending"
                                  : item == "Updated Date"
                                    ? sorting?.isUpdatedDate == "0" ||
                                      sorting?.isUpdatedDate == ""
                                      ? "Descending"
                                      : "Ascending"
                                    : item == "Remaining Renew Days"
                                      ? sorting?.isRenewDays == "0" ||
                                        sorting?.isRenewDays == ""
                                        ? "Descending"
                                        : "Ascending"
                                      : item == "Verified By"
                                        ? sorting?.isVerifyBy == "0" ||
                                          sorting?.isVerifyBy == ""
                                          ? "Descending"
                                          : "Ascending"
                                        : item == "Payment Date"
                                          ? sorting?.isPaymentDate == "0" ||
                                            sorting?.isPaymentDate == ""
                                            ? "Descending"
                                            : "Ascending"
                                          : ""
                            }
                          >
                            {" "}
                            <SwapVertIcon
                              sx={{ fontSize: "1.2rem", cursor: "pointer" }}
                              onClick={() =>
                                setSorting({
                                  isPpskId:
                                    item == "PPSK ID"
                                      ? sorting?.isPpskId == "0"
                                        ? "1"
                                        : sorting?.isPpskId == "1"
                                          ? "0"
                                          : "0"
                                      : "",
                                  isSubmittedDate:
                                    item == "Submitted Date"
                                      ? sorting?.isSubmittedDate == "0"
                                        ? "1"
                                        : sorting?.isSubmittedDate == "1"
                                          ? "0"
                                          : "0"
                                      : "",
                                  isUpdatedDate:
                                    item == "Updated Date"
                                      ? sorting?.isUpdatedDate == "0"
                                        ? "1"
                                        : sorting?.isUpdatedDate == "1"
                                          ? "0"
                                          : "0"
                                      : "",
                                  isRenewDays:
                                    item == "Remaining Renew Days"
                                      ? sorting?.isRenewDays == "0"
                                        ? "1"
                                        : sorting?.isRenewDays == "1"
                                          ? "0"
                                          : "0"
                                      : "",
                                  isVerifyBy:
                                    item == "Verified By"
                                      ? sorting?.isVerifyBy == "0"
                                        ? "1"
                                        : sorting?.isVerifyBy == "1"
                                          ? "0"
                                          : "0"
                                      : "",
                                  isPaymentDate:
                                    item == "Payment Date"
                                      ? sorting?.isPaymentDate == "0"
                                        ? "1"
                                        : sorting?.isPaymentDate == "1"
                                          ? "0"
                                          : "0"
                                      : "",
                                })
                              }
                            />
                          </CustomTooltip>
                        )}
                    </Typography>
                  </StyledTableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ border: `1px solid lightgrey` }}>
            {children}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  );
};

export default CommonTable;
